"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "buglio-in-monte": {
    "ab1d4578": [{
      "hkey": "2b087c72",
      "slug": "buglio-in-monte",
      "name": "Buglio in Monte",
      "primary": true,
      "skipSearch": false
    }],
    "ere": [{
      "hkey": "2b087c72",
      "slug": "buglio-in-monte",
      "name": "Buglio in Monte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3c219e5e": [{
      "hkey": "2b087c72",
      "slug": "buglio-in-monte",
      "name": "Buglio in Monte",
      "primary": true,
      "skipSearch": false
    }],
    "ronco": [{
      "hkey": "2b087c72",
      "slug": "buglio-in-monte",
      "name": "Buglio in Monte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;